import React, { useState, useEffect, useContext, useRef } from "react";
import GoBack from "../../components/goBack";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import $ from "jquery";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import NewClient from "../Items/NewClient";
import moment from "moment";
import { formatNumber, isNumeric } from "../../helpers/formater";
import useAuthHelper from "../../helpers/AuthHelper";
/**
 * create new Incoice
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function NewInvoice(props) {
  const { onlyCommercial, hadAddAccess } = useAuthHelper();

  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const [clients, setClients] = useState([]);
  const [products, setProducts] = useState([]);

  //new product to invoice state
  const [productId, setProductId] = useState();
  const [qty, setQty] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [tva, setTva] = useState(0);
  const [totalHt, setTotalHt] = useState(0);
  const [totalTtc, setTotalTtc] = useState(0);
  const [details, setDetails] = useState(""); // New state for product details

  const [singleSelectedProduct, setSingleSelectedProduct] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [invoiceProductsState, setInvoiceProductsState] = useState([]);
  let invoiceProducts = [];

  //useRef
  const leTotalHt = useRef(0);
  const leTotalTTc = useRef(0);

  //summary
  const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);

  //edit product
  const [productIdToEdit, setProductIdToEdit] = useState(0);
  const [isSubmit, setIsSubmit] = useState(false);

  //form state
  /**
   * {
   *     "value": 92,
   *     "label": "test testchoulla"
   * }
   */

  const currentYear = new Date().getFullYear();
  const firstDayOfYear = `${currentYear}-01-01`;
  const lastDayOfYear = `${currentYear}-12-31`;

  const date_now = new Date();
  const [client, setClient] = useState([]);
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState(
    date_now ? moment(date_now).format("yyyy-MM-DD") : "",
  );
  const [invoiceStatusCreatedAt, setInvoiceStatusCreatedAt] = useState("");
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [banquePaymentOption, setBanquePaymentOption] = useState("");
  const [chequeId, setChequeId] = useState("");
  const [effetId, setEffetId] = useState("");
  const [objet, setObjet] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");

  const [payedAmount, setPayedAmount] = useState(0);
  const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] =
    useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [lastInvoiceNumber, setLastInvoiceNumber] = useState(0);
  const [numeroDeLaFacture, setNumeroDeLaFacture] = useState(0);
  const [selectedProductQty, setSelectedProductQty] = useState(0);
  const [banqueAccounts, setBanqueAccounts] = useState([]);
  const [showBanqueOption, setShowBanqueOption] = useState(0);
  const [bqAccountId, setBqAccountId] = useState(0);
  const [caisseAccountId, setCaisseAccountId] = useState("");
  const errorMessage = "Tous les champs sont obligatoire !";
  const [isService, setIsService] = useState(false);
  const [nbInvoices, setNbInvoices] = useState(0);
  const [invoicesNums, setInvoicesNums] = useState([]);
  const [numExist, setExitNum] = useState(false);
  const [totalTTc, setTotalTTC] = useState();

  // sous compte comptable des paiement
  const [sousCompte, setSousCompte] = useState("");
  const [sousCompteCs, setSousCompteCs] = useState("");
  const [sousComptes, setSousComptes] = useState([]);
  const [sousComptesCs, setSousComptesCs] = useState([]);
  // depots
  const [selectedDepotId, setSelectedDepotId] = useState("");

  const MAX_TITLE_LENGTH = 255;

  useEffect(() => {
    onlyCommercial();
    hadAddAccess();
    console.log("tchanga", invoiceProductsState);
    calcInvoiceSummary(invoiceProductsState);
  }, [invoiceProductsState]);

  const handleAutoIncrementInvoiceNumber = () => {
    if (autoIncrementInvoiceNumber === false) {
      $("#invoiceNumberInput").css("display", "none");
    } else {
      $("#invoiceNumberInput").css("display", "block");
    }
  };
  /**
   * get all associated clients
   *
   * @returns {Promise<void>}
   */
  const getAllAssociatedClients = async () => {
    const response = await axios
      .get(baseURL + `/client/getbyuser/${user.id}/client/${organisation.id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
          $("#warning-create-client-first").css("display", "block");
        } else {
          $("#warning-create-client-first").css("display", "none");
          setClients(transformClientsArray(response.data.data));
          console.log("lcintes : ", clients);
          /**
           * {
           *     "value": 56,
           *     "label": "Commodi minus omnis Ipsum ullam architec"
           * }
           */
        }
      })
      .catch((error) => console.log("error " + error));
  };

  const getAccounts = async () => {
    await axios
      .get(baseURL + "/paymentAccounts")
      .then((response) => {
        setBanqueAccounts(response.data.data);
        response.data.data.map((a) => {
          if (a.name === "Banques (soldes débiteurs)") {
            setBqAccountId(a.id);
          } else if (a.name === "Caisses") {
            setCaisseAccountId(a.id);
          }
        });
        console.log("banque accout: ", banqueAccounts);
      })
      .catch((error) =>
        console.log("error while retrieving setBanqueAccounts : " + error),
      );
  };
  const getAllAssociatedProducts = async () => {
    const response = await axios
      .get(baseURL + `/product/getbyuser/${user.id}/${organisation.id}`)
      .then((response) => {
        setProducts(transformProductsArray(response.data.data));
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );
  };
  console.log("productsss", products);
  const transformClientsArray = (clients) => {
    let array = [];
    for (let i = 0; i < clients.length; i++) {
      let obj = {
        value: clients[i].id,
        label: clients[i].companyName + " - " + clients[i].account.code,
      };
      array.push(obj);
    }
    return array;
  };

  const calcInvoiceSummary = (invoiceProducts) => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;
    for (let i = 0; i < invoiceProductsState.length; i++) {
      totalHt += parseFloat(invoiceProductsState[i].totalHt);
      totalTtc += parseFloat(invoiceProductsState[i].totalTtc);
      totalTva +=
        parseFloat(invoiceProductsState[i].totalTtc) -
        parseFloat(invoiceProductsState[i].totalHt);
    }
    setSummaryTotatlHt(totalHt);
    setSummaryTotalTva(totalTva);
    setSummaryTotatlTtc(totalTtc);
  };

  const hideOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasBottom");

    const offcanvas =
      window.bootstrap?.Offcanvas.getInstance(offcanvasElement) ||
      new window.bootstrap.Offcanvas(offcanvasElement);

    offcanvas.hide();
  };
  const addNewProductToInvoice = async () => {
    if (
      selectedProduct.value === null ||
      qty === 0 ||
      unitPrice === 0 ||
      leTotalHt.current.value === 0 ||
      leTotalTTc.current.value === 0 ||
      details.trim() === ""
    ) {
      toast.warning(t("Tous les champs sont obligatoire !"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      return;
    }

    $("#all-fields-are-required").css("display", "none");

    // Check if product already exists BEFORE closing the Offcanvas
    if (checkIfProductAlreadyExist(singleSelectedProduct.value)) {
      toast.error(t("Ce produit est déjà présent dans la liste !"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      return;
    }

    $("#warning-product-already-exists").css("display", "none");

    // Close Offcanvas only if the product is valid
    hideOffcanvas();

    /**
     * Prepare product
     */
    let product = {
      product_id: singleSelectedProduct.value,
      name: singleSelectedProduct.label,
      isService: singleSelectedProduct.isService,
      qty: qty,
      unitPrice: unitPrice,
      tva: tva,
      totalHt: leTotalHt.current.value,
      totalTtc: leTotalTTc.current.value,
      details: details,
      depot_id: selectedDepotId || "",
    };

    invoiceProducts.push(product);
    setInvoiceProductsState([...invoiceProductsState, product]);

    console.log(product);
  };
  const checkIfProductAlreadyExist = (productId, exceptProductId = null) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      const currentProductId = Number(invoiceProductsState[i].product_id);
      const targetProductId = Number(productId);
      const excludedProductId =
        exceptProductId === null ? null : Number(exceptProductId);

      if (
        currentProductId === targetProductId &&
        (excludedProductId === null || currentProductId !== excludedProductId)
      ) {
        console.log("exist");
        return true;
      }
    }
    console.log("! exist");
    return false;
  };
  const getProductData = async (selectedProduct) => {
    console.log(selectedProductQty);

    //selectedProduct
    const response = await axios
      .get(baseURL + `/product/get/${selectedProduct.value}`)
      .then((response) => {
        setUnitPrice(response.data.data[0]["sellingPrice"]);
        if (selectedProduct?.isService) {
          setIsService(true);
          setQty(1);
        } else {
          setQty(0);
        }
        setTva(response.data.data[0]["taxe_vente"].rate);
      })
      .catch((error) => console.log("error " + error));
  };
  const transformProductsArray = (products) => {
    let array = [];
    for (let i = 0; i < products.length; i++) {
      let obj = {
        value: products[i].id,
        label: products[i].name,
        qty: products[i].qty,
        isService: products[i]?.type === "Marchandise" ? false : true,
        //ajouter depots
        depots: products[i].depot,
      };
      array.push(obj);
    }
    return array;
  };

  const getNbsInvoices = async () => {
    let resp = await jwtInterceoptor.get(
      `/data/nb-factures/factures/${organisation?.id}`,
    );
    if (resp.status == 200) {
      let data = resp.data;
      if (data?.status) {
        setNbInvoices(data?.nb_factures);
        setInvoicesNums(data.data);
      }
    }
  };

  useEffect(() => {
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");
    getAllAssociatedClients();
    getAllAssociatedProducts();
    getInvoiceStatus();
    getIncrementedInvoiceNumber();
    getAccounts();
    getNbsInvoices();
    fetchSousAccounts();
    fetchSousCompteCs();
  }, []);

  const fetchSousAccounts = async () => {
    await jwtInterceoptor
      .get("/data/user/bq/accounts/" + organisation.id)
      .then((res) => {
        setSousComptes(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchSousCompteCs = async () => {
    await jwtInterceoptor
      .get("/data/user/cs/accounts/" + organisation.id)
      .then((res) => {
        setSousComptesCs(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getInvoiceStatus = async () => {
    const response = await API.get("/factures/status")
      .then((res) => {
        setInvoiceStatus(res.data.data);
      })
      .catch((error) => console.log(error));
  };
  const deleteSingleProduct = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        invoiceProductsState.splice(i, 1);
        console.log("spliced");
      }
    }
    setInvoiceProductsState([...invoiceProductsState]);
  };

  const editSingleProduct = (productId) => {
    $(".select-article").css("display", "none");
    $(".add-new-product-to-invoice-btn").css("display", "none");
    $(".edit-single-product").css("display", "revert");
    setProductIdToEdit(productId);

    let product = invoiceProductsState.filter(
      (p) => p.product_id === productId,
    );

    const selectedProductOption = products.find((p) => p.value === productId);
    setSingleSelectedProduct(selectedProductOption || []);

    setQty(product[0]["qty"]);
    setUnitPrice(product[0]["unitPrice"]);
    setTva(product[0]["tva"]);
    setDetails(product[0]["details"]); // Set details for editing
  };
  /**
   * {
   *     "product_id": 75,
   *     "name": "Funny Morning Sarcastic SVG, Sarcastic Morning SVG, Sarcastic SVG, Sarcasm svg, Funny Mug svg,Cut File for Cricut,Silhouette",
   *     "qty": "1",
   *     "unitPrice": 100,
   *     "tva": 20,
   *     "totalHt": "100",
   *     "totalTtc": "120"
   *     'product_id': singleSelectedProduct.value,
   *                 'name': singleSelectedProduct.label,
   *                 'qty': qty,
   *                 'unitPrice': unitPrice,
   *                 'tva': tva,
   *                 'totalHt': leTotalHt.current.value,
   *                 'totalTtc': leTotalTTc.current.value
   * }
   */
  const editSingleInvoiceProduct = () => {
    if (
      selectedProduct.value === null ||
      qty === 0 ||
      unitPrice === 0 ||
      leTotalHt.current.value === 0 ||
      leTotalTTc.current.value === 0 ||
      details.trim() === "" // Ensure details are provided
    ) {
      toast.warning(t("Tous les champs sont obligatoire !"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      //$("#all-fields-are-required").css('display', 'block');
    } else {
      const newProductId = singleSelectedProduct?.value || productIdToEdit;
      if (checkIfProductAlreadyExist(newProductId, productIdToEdit)) {
        toast.error(t("Ce produit est déjà présent dans la liste !"), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }

      $("#all-fields-are-required").css("display", "none");
      hideOffcanvas();
      for (let i = 0; i < invoiceProductsState.length; i++) {
        if (invoiceProductsState[i].product_id === productIdToEdit) {
          invoiceProductsState[i].product_id = newProductId;
          invoiceProductsState[i].name =
            singleSelectedProduct?.label || invoiceProductsState[i].name;
          invoiceProductsState[i].isService = !!singleSelectedProduct?.isService;
          invoiceProductsState[i].qty = qty;
          invoiceProductsState[i].unitPrice = unitPrice;
          invoiceProductsState[i].totalHt = leTotalHt.current.value;
          invoiceProductsState[i].totalTtc = leTotalTTc.current.value;
          invoiceProductsState[i].details = details; // Update details
          invoiceProductsState[i].depot_id = selectedDepotId;
        }
        setInvoiceProductsState([...invoiceProductsState]);
        console.log(invoiceProductsState);
      }
    }
  };

  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    emptyInputs();
  };
  const emptyInputs = () => {
    setSingleSelectedProduct([]);
    setSelectedProduct([]);
    setQty(0);
    setUnitPrice("");
    setTva(0);
    setTotalHt("");
    setTotalTTC("");
    setDetails("");
    setIsService(false);
  };
  const getIncrementedInvoiceNumber = async () => {
    let value = 0;
    const response = await jwtInterceoptor
      .get("/data/user/factures/last/" + organisation.id)
      .then((res) => {
        if (res.data.data !== null) {
          console.log("getIncrementedInvoiceNumber: ", res.data.data.id);
          setNumeroDeLaFacture(res.data.data.id + 1);
        } else {
          setNumeroDeLaFacture(1);
        }
      })
      .catch((error) => console.log("error while save", error));
  };

  const save = () => {
    if (objet.trim().length > MAX_TITLE_LENGTH) {
      toast.error(
        t(`Le titre ne doit pas dépasser ${MAX_TITLE_LENGTH} caractères.`),
        {
          position: "top-right",
          autoClose: 5000,
          theme: "colored",
        },
      );
      return;
    }
    let isOkToSave = true;
    isOkToSave = !(
      client.value === undefined ||
      selectedStatus === "" ||
      selectedStatus === 0 ||
      invoiceDueDate.length === 0 ||
      invoiceCreatedAt.length === 0 ||
      invoiceProductsState.length === 0 ||
      objet.length === 0 ||
      (autoIncrementInvoiceNumber === false && invoiceNumber === "")
    );

    //etat= payé
    if (
      selectedStatus === "2" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToSave = false;
    }
    if (
      selectedStatus === "2" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType === caisseAccountId.toString()) {
        isOkToSave = true;
      } else {
        if (banquePaymentOption.length === 0) {
          isOkToSave = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToSave = false;
          }
        }
      }
    }

    //etat = payé en partie
    if (
      selectedStatus === "3" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToSave = false;
    }

    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType !== bqAccountId && payedAmount === 0) {
        isOkToSave = false;
      } else {
        if (paymentType === bqAccountId && banquePaymentOption.length === 0) {
          isOkToSave = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToSave = false;
          }
        }
      }
    }
    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      payedAmount === 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      isOkToSave = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === bqAccountId.toString() &&
      (sousCompte.length === 0 || sousCompte === 0)
    ) {
      isOkToSave = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === caisseAccountId.toString() &&
      (sousCompteCs.length === 0 || sousCompteCs === 0 || sousCompteCs === "0")
    ) {
      isOkToSave = false;
    }

    if (invoiceNumber.length > 0) {
      isOkToSave = !numExist;
    }

    if (isOkToSave) {
      let numeroDeFacture = "";
      let numeroDeBnLivraison = "";

      let preparedProducts = [];
      let is_custom_invoice_number = 0;
      if (autoIncrementInvoiceNumber === false) {
        is_custom_invoice_number = 1;
        numeroDeFacture = isNumeric(invoiceNumber)
          ? `FACT-VENTE-${formatNumber(invoiceNumber)}`
          : `FACT-VENTE-${invoiceNumber}`;
        numeroDeBnLivraison = isNumeric(invoiceNumber)
          ? `bn-livraison-${formatNumber(invoiceNumber)}`
          : "bn-livraison-" + formatNumber(invoiceNumber);
      } else {
        numeroDeFacture = `FACT-VENTE-${nbInvoices + 1}`;
        numeroDeBnLivraison = `bn-livraison-${nbInvoices + 1}`;
      }
      console.log("invoiceProductsState", invoiceProductsState);
      for (let i = 0; i < invoiceProductsState.length; i++) {
        const ref = Math.random().toString(36).substring(2, 7);
        let obj = {
          product_id: invoiceProductsState[i].product_id,
          price_unit_ht: invoiceProductsState[i].unitPrice,
          qty: invoiceProductsState[i].qty,
          total_ht: invoiceProductsState[i].totalHt,
          total_ttc: invoiceProductsState[i].totalTtc,
          tva: invoiceProductsState[i].tva,
          reference: ref,
          details: invoiceProductsState[i].details, // Include details
          // depot_id: invoiceProductsState[i].depot_id || "", // Add depot_id if available
          depot_id: invoiceProductsState[i].isService
            ? null
            : invoiceProductsState[i].depot_id || "",
        };
        preparedProducts.push(obj);
      }
      let formData = new FormData();
      formData.append("user_id", user.id);
      formData.append("organisation_id", organisation.id);
      formData.append("client_id", client.value);
      formData.append("total_ht", summaryTotatlHt);
      formData.append("total_ttc", summaryTotatlTtc);
      formData.append("total_tva", summaryTotalTva);

      formData.append("title", objet);
      formData.append("due_date", invoiceDueDate);
      formData.append("created_at_date", invoiceCreatedAt);
      formData.append("status", selectedStatus);
      formData.append("payed_amount", Number(payedAmount).toFixed(2));

      formData.append("products", JSON.stringify(preparedProducts));
      formData.append("invoice_number", numeroDeFacture);
      formData.append("numeroDeBnLivraison", numeroDeBnLivraison);
      formData.append("is_custom_invoice_number", is_custom_invoice_number);
      formData.append("depot_id", selectedDepotId);
      if (paymentType === bqAccountId.toString()) {
        formData.append("payment_method", sousCompte === "" ? 0 : sousCompte);
        formData.append("payment_account", sousCompte);
      } else if (paymentType === caisseAccountId.toString()) {
        formData.append(
          "payment_method",
          sousCompteCs === "" ? 0 : sousCompteCs,
        );
        formData.append("payment_account", sousCompteCs);
      } else {
        formData.append("payment_method", paymentType === "" ? 0 : paymentType);
        formData.append("payment_account", paymentType);
      }

      //formData.append("payment_method", sousCompte === '' ? 0 : sousCompte);
      //formData.append("payment_method", paymentType === '' ? 0 : paymentType);

      //formData.append("payment_account", sousCompte);
      //formData.append("payment_account", paymentType);
      if (paymentType === bqAccountId.toString()) {
        formData.append("banquePaymentOption", banquePaymentOption);
        if (banquePaymentOption == "effet") {
          formData.append("effetId", effetId);
          console.log("effet", effetId);
        } else {
          formData.append("chequeId", chequeId);
        }
      } else {
        formData.append("banquePaymentOption", "");
        formData.append("chequeId", "");
        formData.append("effetId", "");
      }

      //formData.append("banquePaymentOption", banquePaymentOption);
      //formData.append("chequeId", chequeId);
      formData.append("payed_invoice_created_at", invoiceStatusCreatedAt);

      if (selectedAttachment) {
        formData.append("attachment_file", selectedAttachment);
      }

      saveInvoice(formData);
    } else {
      console.log("!ok to save");
      const errorMessage = "Merci de remplir tout les champs obligatoire !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleInvoiceStatusCreatedAtChange = (e) => {
    const selectedDate = e.target.value;
    setInvoiceStatusCreatedAt(selectedDate);

    if (!invoiceDueDate) {
      toast.error("La date d'échéance n'est pas encore fixée !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setInvoiceStatusCreatedAt("");
      return;
    }

    const createdAtDate = new Date(selectedDate);
    const dueDate = new Date(invoiceDueDate);

    if (createdAtDate < dueDate) {
      toast.warn(
        "la date de paiement que vous avez choisie est antérieure à la date d'échéance, Veuillez vérifier la date ou confirmer cette opération",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        },
      );
    }
  };

  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const fileAtta = useRef();
  const saveInvoice = async (invoice) => {
    setIsSubmit(true);
    const response = await jwtInterceoptor
      .post("/data/user/factures/add", invoice, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("response: ", res);
        console.log("saved !!!! ", res);
        setIsSubmit(false);
        if (!res?.data || res.data.status === false || res.data.error) {
          Swal.fire(
            t("Erreur"),
            t(res?.data?.message || "La facture n'a pas pu être créée"),
            "error",
          );
          return;
        }
        Swal.fire(t("La facture a été créée avec succès"), t(""), "success");
        navigate("/sales/invoices/list");
      })
      .catch((error) => {
        console.log("error while save", error);
        Swal.fire(t("Erreur"), t(error?.response?.data?.message), "error");
        setIsSubmit(false);
      });
  };

  const onFileUpload = (event) => {
    if (event.target?.files[0]) {
      console.log("event.target.files[0] : " + event.target.files[0]);
      setSelectedAttachment(event.target.files[0]);
    } else {
      console.log("else");
    }
  };

  const onSaveClient = () => {
    getAllAssociatedClients();
    window.$("#newClientModal").modal("hide");
    console.log("has been saved");
    Swal.fire(t("Le client a été ajouter avec succès"), t(""), "success");
  };

  return (
    <>
      <ToastContainer />

      <div className="main-container container-fluid">
        <GoBack route="/sales/invoices/list" />

        <div className="page-header">
          <h1 className="page-title breadcumpsHeader">
            {t("Facture de vente")}
          </h1>
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  href="javascript:void(0)"
                  onClick={() => navigate("/sales/invoices/list")}
                >
                  {t("Liste des factures de vente")}
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {t("Ajouter une facture de vente")}
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div
                className="alert alert-danger alert-dismissible fade show mb-0 all-fields-are-required-to-save"
                role="alert"
              >
                <span className="alert-inner--icon">
                  <i className="fe fe-slash"></i>
                </span>
                <span className="alert-inner--text">
                  <strong></strong> {t("Tous les champs sont obligatoire !")}
                </span>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <br />
              <div
                class="modal fade"
                id="newClientModal"
                tabIndex="-1"
                aria-labelledby="newClientModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="newClientModal">
                        {t("Ajouter un nouveaux client")}
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <NewClient
                        clientType={"client"}
                        from={"new_fv"}
                        handleSave={onSaveClient}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <h4>{t("Espace client")}</h4>
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("Nom du client")}*
                    </label>
                    <Select
                      options={clients}
                      onChange={(choice) => setClient(choice)}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("Nouveau Client")}
                    </label>
                    <a
                      className="btn btn-primary form-control"
                      data-bs-toggle="modal"
                      data-bs-target="#newClientModal"
                    >
                      <i className="fe fe-user"></i> {t("ajouter un client")}
                    </a>
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h4>{t("Informations sur la facture")}</h4>
              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("N° de la facture")} * (
                      {t(
                        "ce numéro servira de référence pour votre facture originale",
                      )}
                      )
                    </label>
                    <input
                      type="text"
                      placeholder="Fact-vente--0001"
                      className={`form-control `}
                      onChange={(e) => {
                        setInvoiceNumber(e.target.value);
                        let numExist = invoicesNums.findIndex(
                          (c) =>
                            e.target.value == c?.invoice_number ||
                            e.target.value ==
                              (c.is_custom_invoice_number == 1
                                ? c.invoice_number
                                : `Fact-vente-${formatNumber(
                                    c?.invoice_number,
                                  )}`),
                        );
                        if (numExist != -1) {
                          setExitNum(true);
                        } else {
                          setExitNum(false);
                        }
                      }}
                      value={invoiceNumber}
                      id={"invoiceNumberInput"}
                    />
                    {!autoIncrementInvoiceNumber && numExist ? (
                      <span className={"text-danger"}>
                        {t("Ce numéro de facture existe déjà")}
                      </span>
                    ) : null}
                    <label className="custom-control custom-checkbox-md">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        name="example-checkbox5"
                        value="option5"
                        checked={autoIncrementInvoiceNumber}
                        onClick={() =>
                          setAutoIncrementInvoiceNumber(
                            !autoIncrementInvoiceNumber,
                          )
                        }
                        onChange={(e) => {
                          handleAutoIncrementInvoiceNumber();
                        }}
                      />
                      <span className="custom-control-label">
                        {t("Utiliser le numéro de facture auto-incrementer")}
                      </span>
                    </label>
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("Objet")}*
                    </label>
                    <input
                      id="invoiceTitle"
                      type="text"
                      placeholder="objet"
                      className="form-control"
                      value={objet}
                      // maxLength={MAX_TITLE_LENGTH}
                      onChange={(e) => setObjet(e.target.value)}
                      // aria-invalid={objet.length > MAX_TITLE_LENGTH}
                      aria-describedby="invoice-title-help"
                    />
                    <small
                      id="invoice-title-help"
                      className={
                        objet.length > MAX_TITLE_LENGTH
                          ? "text-danger"
                          : "text-muted"
                      }
                    >
                      {objet.length}/{MAX_TITLE_LENGTH} caractères maximum
                    </small>
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h5>{t("Les dates")}</h5>
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("date de facture")}*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceCreatedAt(e.target.value)}
                      value={invoiceCreatedAt}
                      //min={firstDayOfYear}
                      //max={lastDayOfYear}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("date d'échéance")}*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceDueDate(e.target.value)}
                      value={invoiceDueDate}
                      min={firstDayOfYear}
                    />
                  </div>
                </div>
              </div>

              <hr className={"custom-hr"} />
              <h5>{t("Produits/Services")}</h5>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">{t("DÉTAILS DE L’ARTICLE")}</th>
                    <th scope="col">{t("QUANTITÉ")}</th>
                    <th scope="col">{t("PU HT")}</th>
                    <th scope="col">{t("TVA %")}</th>
                    <th scope="col">{t("Total HT")}</th>
                    <th scope="col">{t("Total TTC")}</th>

                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                {invoiceProductsState.map((product) => {
                  return (
                    <tr key={product.product_id}>
                      <td>
                        {product.name}-{product.details}
                      </td>
                      <td>{product.qty}</td>
                      <td>{product.unitPrice}</td>
                      <td>{product.tva + "%"}</td>
                      <td>{product.totalHt}</td>
                      <td>{product.totalTtc}</td>

                      <td>
                        <i
                          onClick={() =>
                            deleteSingleProduct(product.product_id)
                          }
                          className="fe fe-trash"
                        ></i>
                      </td>
                      <td>
                        <i
                          data-bs-toggle="offcanvas"
                          aria-controls="offcanvasBottom"
                          data-bs-target="#offcanvasBottom"
                          onClick={() => {
                            setIsService(product.isService);
                            setDetails(product.details); // Set details for editing
                            editSingleProduct(product.product_id);
                          }}
                          className="fe fe-edit"
                        ></i>
                      </td>
                    </tr>
                  );
                })}
              </table>
              <center>
                <button
                  onClick={changeOfCanvasLayouts}
                  className="btn btn-primary off-canvas btn-sm mb-1"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasBottom"
                  aria-controls="offcanvasBottom"
                >
                  <i className="fe fe-plus"></i>
                  {t("ajouter un article")}
                </button>
              </center>

              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}></div>
                <div className={"col-md-6 d-flex flex-row-reverse"}>
                  <div className="row">
                    <div className="invoiceSummary">
                      <table>
                        <tr>
                          <td className={"invoiceSummary-base"}>
                            {t("Total HT")} :
                          </td>
                          <td>
                            {Number(summaryTotatlHt).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>
                            {t("Total TVA")} :
                          </td>
                          <td>
                            {Number(summaryTotalTva).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>
                            {t("Total TTC")} :
                          </td>
                          <td>
                            {Number(summaryTotatlTtc).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div class="form-group">
                    <label className="form-label">
                      {t("Glissez ou déplacez la piéce")} (
                      <span className="text-red">
                        {t("Fichier PDF/Image, taille Max 2 Mo")}
                      </span>
                      )
                    </label>
                    <input
                      className="form-control form-control-lg"
                      type="file"
                      onChange={onFileUpload}
                      ref={fileAtta}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {t("Etat")}*
                    </label>
                    <select
                      className="form-select form-select-lg"
                      id="buyPriceAccountInput"
                      onChange={(e) => setSelectedStatus(e.target.value)}
                      value={selectedStatus}
                    >
                      <option value="0">
                        {t("sélectionner l'état de la facture")}
                      </option>
                      {invoiceStatus.map((status) => {
                        return <option value={status.id}>{status.name}</option>;
                      })}
                    </select>
                  </div>
                  <div
                    className="paymentSection"
                    style={{
                      display:
                        selectedStatus === "2" || selectedStatus === "3"
                          ? "block"
                          : "none",
                    }}
                  >
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1" className="">
                        {t("Date de règlement")}*
                      </label>
                      <input
                        type="date"
                        placeholder="nom"
                        className={`form-control `}
                        onChange={handleInvoiceStatusCreatedAtChange}
                        value={invoiceStatusCreatedAt}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1" className="">
                        {t("Banque ou Caisse")}*
                      </label>
                      <select
                        className="form-select"
                        id="buyPriceAccountInput"
                        onChange={(e) => {
                          setPaymentType(e.target.value);
                        }}
                        value={paymentType}
                      >
                        <option value="0">
                          {t("selectionner un mode de réglement")}
                        </option>
                        {banqueAccounts.map((account) => (
                          <option value={account.id}>
                            {account.code + " - " + account.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className="form-group"
                      style={{
                        display:
                          paymentType === "" + bqAccountId + ""
                            ? "block"
                            : "none",
                      }}
                    >
                      <label htmlFor="sousCompte" className="">
                        {t("Sous Compte")}*
                      </label>
                      <select
                        className="form-select"
                        id="sousCompte"
                        onChange={(e) => {
                          setSousCompte(e.target.value);
                        }}
                        value={sousCompte}
                      >
                        <option value="0">
                          {t("selectionner un sous compte")}
                        </option>
                        {sousComptes.map((account) => (
                          <option value={account.id}>
                            {account.code + " - " + account.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className="form-group"
                      style={{
                        display:
                          paymentType === "" + caisseAccountId + ""
                            ? "block"
                            : "none",
                      }}
                    >
                      <label htmlFor="sousComptecs" className="">
                        {t("Sous Compte")}*
                      </label>
                      <select
                        className="form-select"
                        id="sousComptecs"
                        onChange={(e) => {
                          setSousCompteCs(e.target.value);
                        }}
                        value={sousCompteCs}
                      >
                        <option value="0">
                          {t("selectionner un sous compte")}
                        </option>
                        {sousComptesCs.map((account) => (
                          <option value={account.id}>
                            {account.code + " - " + account.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="banqueOptions">
                      <div
                        className="verementOrChéque"
                        style={{
                          display:
                            paymentType === "" + bqAccountId + ""
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            {t("Mode de Réglement")} *
                          </label>
                          <select
                            className="form-select"
                            id="buyPriceAccountInput"
                            onChange={(e) =>
                              setBanquePaymentOption(e.target.value)
                            }
                            value={banquePaymentOption}
                          >
                            <option value="0">
                              {t("selectionner un mode de réglement")}
                            </option>
                            <option value="virement">{t("Virement")}</option>
                            <option value="chéque">{t("Chéque")}</option>
                            <option value="carte bancaire">
                              {t("Carte Bancaire")}
                            </option>
                            <option value="effet">{t("Effet")}</option>
                            <option value="prélévement">{"Prélévement"}</option>
                          </select>
                        </div>
                      </div>
                      <div
                        className="libelleIfcheque"
                        style={{
                          display:
                            banquePaymentOption === "chéque" &&
                            paymentType === "" + bqAccountId + ""
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            {"Identificateur du chéque"}*
                          </label>
                          <input
                            type="text"
                            placeholder=""
                            className={`form-control `}
                            onChange={(e) => setChequeId(e.target.value)}
                            value={chequeId}
                          />
                        </div>
                      </div>
                      <div
                        className="libelleIfcheque"
                        style={{
                          display:
                            banquePaymentOption === "effet" &&
                            paymentType === "" + bqAccountId + ""
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            {t("Identificateur d'effet")}*
                          </label>
                          <input
                            type="text"
                            placeholder=""
                            className={`form-control `}
                            onChange={(e) => setEffetId(e.target.value)}
                            value={effetId}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="form-group"
                      style={{
                        display: selectedStatus === "3" ? "block" : "none",
                      }}
                    >
                      <label htmlFor="exampleInputEmail1" className="mpLabel">
                        {t("Montant payé")}*
                      </label>
                      <input
                        type="text"
                        placeholder="objet"
                        className={`form-control mpInput`}
                        onChange={(e) => {
                          if (e.target.value >= summaryTotatlTtc) {
                            setPayedAmount(0);
                            toast.error(
                              t(
                                "le mantant payé remplit est supérieur ou égale le total ttc",
                              ),
                              {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: false,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                              },
                            );
                          } else {
                            setPayedAmount(e.target.value);
                          }
                        }}
                        value={payedAmount}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <div className="card-footer">
                <div className="d-flex flex-row-reverse">
                  <button
                    disabled={isSubmit}
                    type="button"
                    className="btn btn-primary"
                    onClick={save}
                  >
                    {isSubmit ? t("Loading ...") : t("Enregistrer")}
                  </button>
                  <button
                    onClick={() => {
                      navigate(-1);
                    }}
                    className="btn btn-default "
                    style={{ marginRight: 10 }}
                  >
                    {t("Annuler")}
                  </button>
                </div>
              </div>

              <div
                className="offcanvas offcanvas-bottom addProductCanvas"
                tabIndex="-1"
                id="offcanvasBottom"
                aria-labelledby="offcanvasBottomLabel"
              >
                <div className="offcanvas-header">
                  <h5 className="offcanvas-title" id="offcanvasBottomLabel">
                    {t("Renseigner le produit à ajouter.")}
                  </h5>
                  <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  >
                    <i className="fe fe-x fs-18"></i>
                  </button>
                </div>
                <div className="offcanvas-body">
                  <div id="all-fields-are-required">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        <strong>{t("Attention")}!</strong>{" "}
                        {t("Tous les champs sont obligatoire")} !
                      </span>
                    </div>
                    <br />
                  </div>

                  <div id="warning-product-already-exists">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        <strong>{t("Attention")}!</strong>{" "}
                        {t("Ce produit est déjà présent dans la liste !")}
                      </span>
                    </div>
                    <br />
                  </div>

                  <div id="qty-is-higher">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        {/* <strong>{"Attention"}!</strong> il réste{" "}
                        {selectedProductQty} articles en stock{" "} */}
                        <span className="alert-inner--text">
                          {selectedProductQty === 0 ? (
                            <strong>Rupture de stock</strong>
                          ) : (
                            <>
                              <strong>{"Attention"}!</strong> il réste{" "}
                              {selectedProductQty} articles en stock
                            </>
                          )}
                        </span>
                      </span>
                    </div>
                    <br />
                  </div>

                  <form className="needs-validation" noValidate="">
                    <div className="form-row">
                      <div className="col-xl-12 mb-3">
                        <label
                          className={"select-article"}
                          htmlFor="validationTooltip01"
                        >
                          {t("DÉTAILS DE L’ARTICLE")}*
                        </label>
                        <Select
                          className={"select-article"}
                          value={singleSelectedProduct}
                          options={products}
                          onChange={(choice) => {
                            setQty(0);
                            setSingleSelectedProduct(choice);
                            getProductData(choice);
                            if (!choice?.isService) {
                              setIsService(false);
                            }
                            console.log("chihaja", choice);
                          }}
                        />
                      </div>
                      <div className="col-xl-12 mb-3">
                        {/* {singleSelectedProduct?.depots?.length > 0 && ( */}
                        {!isService &&
                          singleSelectedProduct?.depots?.length > 0 && (
                            <>
                              <label htmlFor="productDepots">
                                {t("Dépôts disponibles")}
                              </label>
                              {singleSelectedProduct.depots.map(
                                (depot, index) => (
                                  <div key={index} className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id={`depot-${index}`}
                                      value={depot.depot_id}
                                      name="productDepot"
                                      onChange={(e) => {
                                        setSelectedDepotId(e.target.value);
                                        setSelectedProductQty(depot.quantity);
                                        console.log(
                                          "productDepot",
                                          e.target.value,
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`depot-${index}`}
                                    >
                                      {depot.depot.name}
                                    </label>
                                  </div>
                                ),
                              )}
                            </>
                          )}
                      </div>
                      <div className="col-xl-3 mb-3" hidden={isService}>
                        <label htmlFor="validationTooltip02">QUANTITÉ*</label>
                        <input
                          className="form-control"
                          id="validationTooltip02"
                          type="number"
                          required
                          value={qty}
                          onChange={(e) => {
                            if (e.target.value > selectedProductQty) {
                              $("#qty-is-higher").css("display", "block");
                            } else {
                              $("#qty-is-higher").css("display", "none");

                              // Parse the quantity to a float and handle negative values
                              const inputValue = parseFloat(
                                parseFloat(e.target.value).toFixed(2),
                              );

                              // Vérifie si la valeur saisie est un nombre valide
                              if (isNaN(inputValue) || inputValue < 0) {
                                setQty(0); // Réinitialise la quantité en cas de saisie invalide
                                setTotalHt("0.00");
                                setTotalTTC("0.00");
                                return;
                              }

                              // Vérifie si la quantité dépasse le stock disponible
                              if (inputValue > selectedProductQty) {
                                setQty(inputValue);
                                setTotalHt("0.00");
                                setTotalTTC("0.00");
                                return;
                              }

                              // Calcule les valeurs
                              const totalHtl = (inputValue * unitPrice).toFixed(
                                2,
                              );
                              const totalTTC = (
                                parseFloat(totalHtl) +
                                (parseFloat(totalHtl) * tva) / 100
                              ).toFixed(2);

                              // Met à jour l'état
                              setQty(inputValue);
                              setTotalHt(totalHtl);
                              setTotalTTC(totalTTC);
                              console.log({
                                unitPrice: parseFloat(inputValue),
                                totalHt: parseFloat(totalHtl),
                                totalTtc: parseFloat(totalTTC),
                              });
                            }
                          }}
                        />
                      </div>
                      <div className="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">
                          {t("PU HT")}*
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="validationTooltip02"
                          // required=""
                          value={unitPrice}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            if (!isNaN(value)) {
                              const total_ht = qty * value;
                              const total_ttc = (
                                total_ht +
                                (total_ht * tva) / 100
                              ).toFixed(2);
                              setUnitPrice(parseFloat(value.toFixed(2)));
                              setTotalHt(parseFloat(total_ht.toFixed(2)));
                              setTotalTTC(parseFloat(total_ttc));
                            }
                          }}
                          // disabled={!isService}
                        />
                      </div>
                      <div className="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">
                          {t("Total HT")}*
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={isService ? unitPrice.toFixed(2) : totalHt}
                          ref={leTotalHt}
                        />
                      </div>
                      <div className="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">
                          {t("Total TTC")}*
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={
                            isService
                              ? (
                                  parseFloat(unitPrice.toFixed(2)) +
                                  (parseFloat(unitPrice.toFixed(2)) * tva) / 100
                                ).toFixed(2)
                              : totalTTc
                          }
                          ref={leTotalTTc}
                        />
                      </div>
                      <div className="col-xl-12 mb-3">
                        <label htmlFor="productDetails">{t("Détails")}*</label>
                        <textarea
                          className="form-control"
                          id="productDetails"
                          rows="3"
                          value={details}
                          onChange={(e) => setDetails(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                    <i
                      className="fe fe-plus btn btn-primary add-new-product-to-invoice-btn"
                      onClick={addNewProductToInvoice}
                    ></i>
                    <i
                      className="fe fe-edit btn btn-primary edit-single-product"
                      onClick={editSingleInvoiceProduct}
                    ></i>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewInvoice;
